module.exports = __webpack_public_path__ + "img/tertiary_10x2_z18.f6c95615.svg";